import { cva } from "class-variance-authority";

// Typography variant utilities that can be shared between Typography component and Markdown
export const typographyVariants = cva("", {
  variants: {
    variant: {
      h1: "al-text-h1",
      h2: "al-text-h2",
      h3: "al-text-h3",
      h4: "al-text-h4",
      h5: "al-text-subheading",
      h6: "al-text-caption",
      subheading: "al-text-subheading",
      body: "al-text-body",
      caption: "al-text-caption",
      button: "", // Button uses size for styling
      "table-header": "al-text-table-header",
      placeholder: "", // Placeholder uses size for styling
      "page-heading": "al-text-h2", // Semantic variant for page headings (fixed h2 + semibold)
      "section-heading": "al-text-h3", // Semantic variant for section headings (fixed h3 + semibold)
    },
    weight: {
      regular: "al-font-regular",
      medium: "al-font-medium",
      semibold: "al-font-semibold",
    },
    size: {
      // Body sizes
      lg: "al-text-body-lg",
      regular: "al-text-body-regular",
      sm: "al-text-body-sm",
      xs: "al-text-body-xs",
      xxs: "al-text-body-xxs",
      // Button sizes
      "button-xs": "al-text-button-xs",
      "button-sm": "al-text-button-sm",
      "button-md": "al-text-button-md",
      // Placeholder sizes
      "placeholder-regular": "al-text-placeholder-regular al-italic",
      "placeholder-large": "al-text-placeholder-large al-italic",
    },
  },
});

// Helper function to get typography classes for markdown elements
export const getMarkdownTypographyClasses = () => {
  return {
    h1: typographyVariants({ variant: "h1", weight: "semibold" }),
    h2: typographyVariants({ variant: "h2", weight: "semibold" }),
    h3: typographyVariants({ variant: "h3", weight: "semibold" }),
    h4: typographyVariants({ variant: "h4", weight: "semibold" }),
    h5: typographyVariants({ variant: "h5", weight: "semibold" }),
    h6: typographyVariants({ variant: "h6", weight: "semibold" }),
    body: typographyVariants({ variant: "body", weight: "regular", size: "regular" }),
    // Non-typography classes
    link: "al-text-blue-500 al-underline",
    list: "al-list-disc al-ml-4 al-mb-4",
    orderedList: "al-list-decimal al-ml-4 al-mb-4",
    blockquote: "al-mt-6 al-border-l-2 al-pl-6 al-italic",
    code: "al-rounded al-p-1 al-font-mono al-text-sm al-font-semibold",
  };
};
